import { mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { ClientAddressCacheMixin } from './ClientAddressCacheMixin'
import { AddressHelper } from '@/helpers/AddressHelper'

export const ClientAddressAddMixin = {
  mixins: [ClientAddressCacheMixin],
  data () {
    return {
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postCode: '',
      clientAddressValidator: AddressHelper.getRegistrationAddressValidator()
    }
  },
  computed: {
    clientAddressAddModel () {
      return {
        line1: this.line1,
        line2: this.line2,
        line3: this.line3,
        town: this.town,
        county: this.county,
        postCode: this.postCode
      }
    }
  },
  methods: {
    ...mapActions('RegistrationClientAddress', [
      'addClientAddress'
    ]),
    tryAddClientAddress () {
      const self = this
      self.clientAddressValidator.check(self.clientAddressAddModel)
      if (!self.clientAddressValidator.isValid) {
        return
      }
      self.error = ''
      return self.addClientAddress({ inviteId: self.inviteId, payload: self.clientAddressAddModel })
        .then(response => { self.afterAddClientAddress(response.data) })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.afterAddClientAddress()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
    },
    afterAddClientAddress () {
      // override if necessary
    }
  }
}
